import React, { createContext, useState } from "react";
import FloatingButton from "../components/ui/materialui/floatingButton";

export interface FloatingButtonContextProps {
    showButton: boolean;
    setShowButton: (value: boolean) => void;
}

export const FloatingButtonContext = createContext<FloatingButtonContextProps | undefined>(undefined);

export const FloatingButtonProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [showButton, setShowButton] = useState(true);

    return (
        <FloatingButtonContext.Provider value={{ showButton, setShowButton }}>
            {children}
            {showButton && <FloatingButton onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} />}
        </FloatingButtonContext.Provider>
    );
};
